import { Box, Card, Image, Text, Button, Flex } from "@chakra-ui/react";
import { useRef, useState, useEffect } from "react";
import { OrbitControls, useGLTF } from '@react-three/drei';
import { motion, useInView, AnimatePresence } from "framer-motion";
import { Canvas } from "@react-three/fiber";

export function AnimatedComponent({children,delay,...props}) {
    const MotionBox = motion.create(Box)
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-50px" });

    return(
        <MotionBox
            ref={ref}
            initial={{ opacity: 0, y: 50 }}          // hidden state
            animate={isInView ? { opacity: 1, y: 0 } : {}}  // animate only once
            transition={{ duration: 1, delay: delay, ease: "easeOut" }}
            {...props}
        >
          {children}
        </MotionBox>
    );
}

export function Offers({images}) {
    const [index, setIndex] = useState(0);

    var MotionBox = motion.create(Box);

    useEffect(() => {
        const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % images.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return(
        <Box maxW="100%" overflowX="hidden">
            <AnimatePresence mode="wait">
                {images[index] && (
                    <MotionBox
                        key={index}
                        initial={{ x: '100vw' }}
                        animate={{ x: 0 }}
                        exit={{ x: '-100vw' }}
                        transition={{ duration: .5, ease: 'easeOut' }}
                    >
                        <Image src={images[index]} w="100%"/>
                    </MotionBox>
                )}
            </AnimatePresence>
        </Box>
    );
}

function Model({ design }) {
  const { scene } = useGLTF(design); // ✅ Hook used inside Canvas context
  return <primitive object={scene} />;
}

export function ReadDesign({design}) {
    return(
        <Canvas style={{ height: "400px" }}>
            <ambientLight intensity={0.5} />
                <directionalLight position={[10, 10, 5]} />
                <OrbitControls />
                <Model design={design} />
        </Canvas>
    );
}

export function ChangeText({texts,size,sizeRoot}) {
    const [index, setIndex] = useState(0);

    var MotionText = motion.create(Text);

    useEffect(() => {
        const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % texts.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return(
        <Box maxH={sizeRoot} overflowY="hidden">
            <AnimatePresence mode="wait">
                {texts[index] && (
                    <MotionText
                        key={index}
                        color={texts[index]["color"]}
                        textStyle={size}
                        lineHeight={sizeRoot}
                        fontWeight={texts[index]["weight"]}
                        initial={{ opacity: 0, y: -100 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 100 }}
                        transition={{ duration: .25 }}
                    >
                        {texts[index]["data"]}
                    </MotionText>
                )}
            </AnimatePresence>
        </Box>
    )
}

export function ServiceCard({ title, description, icon, colors, link, delay, is_main }) {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-50px" });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}          // hidden state
            animate={isInView ? { opacity: 1, y: 0 } : {}}  // animate only once
            transition={{ duration: 1, delay: delay, ease: "easeOut" }}
        >
            <Card.Root
                maxW="sm"
                shadow="xl"
                borderRadius="2xl"
            >
                <Text
                    w="100%" 
                    py={is_main ? "10" : "5"}
                    textStyle={is_main ? "5xl" : "3xl"}
                    color="white"
                    bgGradient="to-tl"
                    alignItems="center"
                    justifyContent="center"
                    display="flex"
                    gradientFrom={colors[0]}
                    gradientTo={colors[1]}
                    borderTopRadius="2xl"
                >
                    {icon}
                </Text>
                <Card.Body gap="2">
                    <Card.Title>{title}</Card.Title>
                    <Card.Description>{description}</Card.Description>
                </Card.Body>
                <Card.Footer gap="2">
                    <Button
                        bgGradient="to-tr"
                        gradientFrom={colors[0]}
                        gradientTo={colors[1]}
                        variant="solid"
                        colorPalette="bg"
                        asChild 
                    ><a href={link}>Klik Disini</a></Button>
                </Card.Footer>
            </Card.Root>
        </motion.div>
    );
}

export function ProjectCard({ image, title, location }) {
  return(
        <Box 
            pos="relative" 
            borderRadius="md" 
            overflow="hidden" 
            transition="transform 0.3s"
            _hover={{ transform: "scale(1.05)" }}
        >
            <Image 
                src={image} 
                alt={title} 
                w="100%" 
                h="300px" 
                objectFit="cover"
            />
            <Box 
                pos="absolute" 
                bottom="0" 
                left="0" 
                right="0" 
                bg="rgba(0,0,0,0.6)" 
                p={4}
            >
                <Text 
                    color="white" 
                    fontWeight="bold"
                >
                    {title}
                </Text>
                <Text 
                    color="white" 
                    opacity="0.8"
                >
                    {location}
                </Text>
            </Box>
        </Box>
  );
} 


export function ImageCarousel({images=[],texts=[],imagesOnMobile=[]}) {
    const [index, setIndex] = useState(0);
    const MotionBox = motion.create(Box);
    const MotionImage = motion.create(Image);
    const MotionText = motion.create(Text);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % images.length);
            }, 10000);
        return () => clearInterval(interval);
    }, []);

  return (
    <Box w="100%">
        <Box position="relative" w="100%" h="600px" overflow="hidden" display={{base:'none',md:'block'}}>
            <AnimatePresence mode="wait">
                <MotionBox
                    key={index}
                    position="absolute"
                    top="0"
                    left="0"
                    w="100%"
                    h="100%"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -50 }}
                    transition={{ duration: 1 }}
                >
                {/* Layer 3 - Background Image */}
                    <MotionImage
                        src={images[index]["data"]}
                        alt="slideshow"
                        objectFit="cover"
                        w="100%"
                        h="100%"
                        position="absolute"
                        top="0"
                        left="0"
                        zIndex={0}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1, delay: 1 }}
                    />

                    <MotionText
                        key={`layer02-${index}`}
                        position="absolute"
                        bottom="0"
                        right="0"
                        color="blue.400"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }} // slightly see-through
                        transition={{ duration: 1, delay: 1 }}
                    > {images[index]["link"]} </MotionText>

                    {/* Layer 2 - Light diagonal overlay */}
                    <MotionBox
                        key={`layer2-${index}`}
                        position="absolute"
                        top="0"
                        left="0"
                        w="100%"
                        h="100%"
                        backgroundGradient="to-bl"
                        gradientFrom="#00c6ff"
                        gradientTo="green.600"
                        clipPath="polygon(0 0, 70% 0, 55% 100%, 0 100%)"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 0.8 }}
                        transition={{ duration: 1, delay: .5 }}
                        zIndex={1}
                    />

                    {/* Layer 1 - Dark Blue overlay */}
                    <MotionBox
                        key={`layer1-${index}`}
                        position="absolute"
                        top="0"
                        left="0"
                        w="100%"
                        h="100%"
                        backgroundGradient="to-br"
                        gradientFrom="#000428"
                        gradientTo="blue.500"
                        clipPath="polygon(0 0, 65% 0, 50% 100%, 0 100%)"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }} // slightly see-through
                        transition={{ duration: 1, delay: 0 }}
                        zIndex={2}
                    />

                    {/* Layer 0 - Text */}
                    <MotionBox
                        key={`layer0-${index}`}
                        position="absolute"
                        top="0"
                        left="0"
                        w="50%"
                        h="100%"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }} // slightly see-through
                        transition={{ duration: 1, delay: 0 }}
                        zIndex={3}
                    >
                        <Flex flexDirection="column" h="100%" pl="10" pt="10" align="center" justifyContent="center">
                            { texts[index]["texts"].map((data,i) => (
                                <MotionText
                                    key={`layer01-${i}-${index}`}
                                    w="100%"
                                    textStyle={data.size}
                                    color={data.color}
                                    fontWeight={data.weight}
                                    marginBottom={data.mb}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }} // slightly see-through
                                    transition={{ duration: 1, delay: 1*i }}
                                > {data.data} </MotionText>
                            ))}
                        </Flex>
                    </MotionBox>
                </MotionBox>
            </AnimatePresence>
        </Box>
        <Box position="relative" w="100%" h="600px" overflow="hidden" display={{base:'block',md:'none'}}>
            <AnimatePresence mode="wait">
                <MotionBox
                    key={index}
                    position="absolute"
                    top="0"
                    left="0"
                    w="100%"
                    h="100%"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -50 }}
                    transition={{ duration: 1 }}
                >

                {/* Layer 3 - Background Image */}
                    <MotionImage
                        src={imagesOnMobile[index]}
                        alt="slideshow"
                        objectFit="cover"
                        w="100%"
                        h="100%"
                        position="absolute"
                        top="0"
                        left="0"
                        zIndex={0}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 2, delay: 0 }}
                    />
                    
                    <MotionBox
                        src={images[index]}
                        alt="slideshow"
                        objectFit="cover"
                        w="100%"
                        h="100%"
                        position="absolute"
                        top="0"
                        left="0"
                        zIndex={0}
                        backgroundGradient="to-tr"
                        gradientFrom="#00c6ff"
                        gradientTo="green.600"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: .5 }}
                        transition={{ duration: 1, delay: 1 }}
                    />

                    {/* Layer 2 - Light diagonal overlay */}
                    <MotionBox
                        key={`layer2-${index}`}
                        position="absolute"
                        top="0"
                        left="0"
                        w="100%"
                        h="100%"
                        backgroundGradient="to-bl"
                        gradientFrom="#FFFF00"
                        gradientTo="#FFB800"
                        clipPath="polygon(0 0, 100% 0, 100% 90%, 50% 85%, 0 90%)"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: .5 }}
                        transition={{ duration: 1, delay: .5 }}
                        zIndex={1}
                    />

                    {/* Layer 1 - Dark Blue overlay */}
                    <MotionBox
                        key={`layer1-${index}`}
                        position="absolute"
                        top="0"
                        left="0"
                        w="100%"
                        h="100%"
                        backgroundGradient="to-br"
                        gradientFrom="#000428"
                        gradientTo="blue.500"
                        clipPath="polygon(0 0, 100% 0, 100% 85%, 50% 80%, 0 85%)"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: .9 }} // slightly see-through
                        transition={{ duration: 1, delay: 0 }}
                        zIndex={2}
                    />

                    {/* Layer 0 - Text */}
                    <MotionBox
                        key={`layer0-${index}`}
                        position="absolute"
                        top="0"
                        left="0"
                        w="100%"
                        h="80%"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }} // slightly see-through
                        transition={{ duration: 1, delay: 0 }}
                        zIndex={3}
                    >
                        <Flex flexDirection="column" justifyContent="center" h="100%" p="10">
                            { texts[index]["texts"].map((data,i) => (
                                <MotionText
                                    key={`layer01-${i}-${index}`}
                                    w="100%"
                                    textAlign="center"
                                    textStyle={data.size}
                                    color={data.color}
                                    marginBottom={data.mb}
                                    fontWeight={data.weight}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }} // slightly see-through
                                    transition={{ duration: 1, delay: 1*i }}
                                > {data.data} </MotionText>
                            ))}
                        </Flex>
                    </MotionBox>
                </MotionBox>
            </AnimatePresence>
        </Box>
    </Box>
  );
}